import { defineStore } from 'pinia';
import api from '@/services/api';

export const useCondicionFiscalStore = defineStore('condicionFiscalStore', {
  state: () => ({
    condicionesFiscales: [],
    page: 1,
  }),

  getters: {},

  actions: {
    async findAllCondicionFiscalHTTP() {
      const result = await api.get('/condicion-fiscal', { params: { page: +this.page } });
      if (result && result.data && result.data.length > 0) {
        this.condicionesFiscales.push(...result.data);
        this.setPage(this.page + 1);
        return true;
      }
      return false;
    },
    setPage(page) {
      this.page = page;
    },
    async firstCondicionFiscal() {
      this.setPage(1);
      this.emptyList();
      await this.findAllCondicionFiscalHTTP();
    },
    emptyList() {
      this.condicionesFiscales = [];
    },
  },
});
